var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysFacebook = function SvgSysFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24.001"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3b5998",
    d: "M12 24A12 12 0 0 1 3.515 3.515a12 12 0 0 1 16.97 16.971A11.921 11.921 0 0 1 12 24ZM9.067 10.452v1.991H10.8v5.109h2.074v-5.109h1.987v-1.991h-1.987V9.181c0-.582.169-.969 1-.969h1.063V6.354h-1.55a2.419 2.419 0 0 0-2.587 2.63v1.469Z",
    "data-name": "Subtra\\xE7\\xE3o 25"
  })));
};
export default SvgSysFacebook;